import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {isNullOrUndefined, isDefined} from '../../../../../commons/utils';
import {IonicModule} from '@ionic/angular';
import {FilterCheckboxComponent} from '../filter-checkbox/filter-checkbox.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-expandable-radio-button-filter',
  imports: [IonicModule, FilterCheckboxComponent, TranslateModule],
  templateUrl: './expandable-radio-button-filter.component.html',
  styleUrls: ['./expandable-radio-button-filter.component.css']
})
export class ExpandableRadioButtonFilterComponent implements OnInit, OnChanges {
  readonly isNullOrUndefined = isNullOrUndefined;
  readonly isDefined = isDefined;

  @Input() filterNameKey: string;
  @Input() filterItems: string[];
  @Input() selectedFilterItem: string;
  @Input() translateString: string;
  @Input() canDisable = true;
  @Output() readonly changeFilters = new EventEmitter<string>();

  isExpanded = false;
  isFilterActive: boolean;

  ngOnChanges(changes: SimpleChanges): void {
    this.isFilterActive = isDefined(this.selectedFilterItem);
  }

  ngOnInit(): void {
    this.isFilterActive = isDefined(this.selectedFilterItem);
  }

  onFilterSelect(checked: boolean, filterItem: string): void {
    if (checked) {
      this.selectedFilterItem = filterItem;
      this.changeFilters.emit(this.selectedFilterItem);
      this.isFilterActive = true;
    } else if (this.canDisable) {
      this.isFilterActive = false;
      this.changeFilters.emit();
    }
  }

  clearFilter(event: MouseEvent): void {
    event.stopPropagation();
    this.isFilterActive = false;
    this.changeFilters.emit();
  }

  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
  }
}
